var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconPlus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12.8C11.1105 12.8 11.2 12.8895 11.2 13L11.2 18.6C11.2 18.8209 11.3791 19 11.6 19H12.4C12.6209 19 12.8 18.8209 12.8 18.6V13C12.8 12.8895 12.8895 12.8 13 12.8H18.6C18.8209 12.8 19 12.6209 19 12.4V11.6C19 11.3791 18.8209 11.2 18.6 11.2H13C12.8895 11.2 12.8 11.1105 12.8 11V5.4C12.8 5.17909 12.6209 5 12.4 5H11.6C11.3791 5 11.2 5.17909 11.2 5.4L11.2 11C11.2 11.1105 11.1105 11.2 11 11.2H5.4C5.17909 11.2 5 11.3791 5 11.6V12.4C5 12.6209 5.17909 12.8 5.4 12.8H11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.d0de921d6eb160022ea43f4b0dd4b92b.svg";
export { ForwardRef as ReactComponent };